<template>
  <div
    class="checkout-builder"
    :style="builderBackground"
    :class="{ mobile: device == 'mobile' }"
  >
    <timer-container />
    <div class="d-lg-none m-5" v-if="editing">
      <bp-button
        variant="outlined-1"
        icon="fa-regular fa-gear"
        @click="menuModal = true"
      />
    </div>
    <div class="checkout-content" :class="{ editing }">
      <desktop-view v-if="device == 'desktop'" />
      <mobile-view v-else-if="device == 'mobile'" />
    </div>

    <responsive-modal v-model="menuModal">
      <settings-menu />
    </responsive-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

import SettingsMenu from "./SettingsMenu.vue";
import TimerContainer from "./container/TimerContainer.vue";
import DesktopView from "./main/DesktopView.vue";
import MobileView from "./main/MobileView.vue";
export default {
  components: { DesktopView, SettingsMenu, MobileView, TimerContainer },
  data() {
    return {
      menuModal: false
    };
  },
  computed: {
    ...mapState("checkoutBuilder", ["background", "device", "editing"]),
    builderBackground() {
      if (this.background?.image) {
        return { backgroundImage: `url(${this.background.image})` };
      }

      return { backgroundColor: this.background.color };
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder {
  min-height: calc(100vh - 72px - 73px);
  background-size: cover;
  background-repeat: no-repeat;

  &.mobile {
    @media screen and (min-width: 992px) {
      width: 450px;
      margin: 0 auto;
    }
  }

  .checkout-content {
    margin: 0 auto;
    padding: 8px 8px 40px;
    width: 1110px;
    max-width: 100%;
    overflow: hidden;

    &.editing {
      width: 750px;
      padding: 16px 16px 100px;
    }

    @media screen and (max-width: 991px) {
      padding-bottom: 150px;
    }
  }

  ::v-deep img {
    width: 100%;
    max-width: 100%;
    backdrop-filter: blur(24px);
  }
}
</style>
